// =============================================================================
// Ella Custom JS - Customize The Style For Layout
// =============================================================================

// =============================================================================
// IMPORTANT DISCLAIMER
// Please use only JS to style the layout.
// =============================================================================

// -----------------------------------------------------------------------------
// AZADI SALE FIX: don't land customers on an out-of-stock variant.
//
// The theme's variant picker correctly checks the first IN-STOCK variant by
// default, but if a customer arrives via a link that points at a specific
// (out-of-stock) variant id — e.g. from a product card, search result, or
// shared link — the picker just accepts whatever variant the URL asked for,
// even if it's sold out, and shows "Sold out" without checking other options.
//
// This runs once after the page loads: if the variant currently selected on
// a product page is unavailable AND a different option combination on the
// same product IS available, it silently re-selects that in-stock
// combination (color/size/etc.) and lets the theme's own existing variant
// logic take over from there — same price/image/button updates as if the
// customer had clicked it themselves. If the product is genuinely sold out
// in every combination, nothing changes.
// -----------------------------------------------------------------------------
document.addEventListener('DOMContentLoaded', function () {
    function getVariantsFromRoot(root) {
        var jsonEl = root.querySelector('[type="application/json"]');
        if (!jsonEl) return null;
        try {
            return JSON.parse(jsonEl.textContent);
        } catch (e) {
            return null;
        }
    }

    function getCurrentOptionValues(root) {
        var fieldsets = Array.prototype.slice.call(root.querySelectorAll('fieldset'));
        if (fieldsets.length) {
            return fieldsets.map(function (fieldset) {
                var checked = fieldset.querySelector('input:checked');
                return checked ? checked.value : null;
            });
        }
        var selects = Array.prototype.slice.call(root.querySelectorAll('select'));
        if (selects.length) {
            return selects.map(function (select) { return select.value; });
        }
        return null;
    }

    function applyVariantSelection(root, variant) {
        var fieldsets = Array.prototype.slice.call(root.querySelectorAll('fieldset'));
        if (fieldsets.length) {
            fieldsets.forEach(function (fieldset, index) {
                var targetValue = variant.options[index];
                if (targetValue == null) return;
                var inputs = Array.prototype.slice.call(fieldset.querySelectorAll('input[type="radio"]'));
                var match = inputs.find(function (input) { return input.value === targetValue; });
                if (match) match.checked = true;
            });
        } else {
            var selects = Array.prototype.slice.call(root.querySelectorAll('select'));
            selects.forEach(function (select, index) {
                var targetValue = variant.options[index];
                if (targetValue != null) select.value = targetValue;
            });
        }
        root.dispatchEvent(new Event('change', { bubbles: true }));
    }

    function fixIfOutOfStock(root) {
        var variants = getVariantsFromRoot(root);
        if (!variants || !variants.length) return;

        var currentOptionValues = getCurrentOptionValues(root);
        if (!currentOptionValues) return;

        var currentVariant = variants.find(function (variant) {
            return variant.options.every(function (optionValue, index) {
                return optionValue === currentOptionValues[index];
            });
        });

        // Already showing an in-stock variant, nothing to do.
        if (currentVariant && currentVariant.available) return;

        var firstAvailable = variants.find(function (variant) { return variant.available; });
        // Every combination is genuinely sold out, nothing we can do.
        if (!firstAvailable) return;

        applyVariantSelection(root, firstAvailable);
    }

    var pickers = document.querySelectorAll('variant-radios, variant-selects');
    pickers.forEach(fixIfOutOfStock);
});

// -----------------------------------------------------------------------------
// AZADI SALE: show the 14% off promo directly under the price on product pages.
// Targets the theme's existing price container by class so it works across
// every product page layout without touching the large product template files.
// -----------------------------------------------------------------------------
document.addEventListener('DOMContentLoaded', function () {
    var priceBlocks = document.querySelectorAll('.productView-price');
    if (!priceBlocks.length) return;

    priceBlocks.forEach(function (priceBlock) {
        if (priceBlock.parentNode.querySelector('.azadi-product-promo')) return;

        var promo = document.createElement('a');
        promo.className = 'azadi-product-promo';
        promo.href = '/collections/all';
        promo.innerHTML = '\u262a 14% off auto-applied on orders above <b>Rs.\u00A09,800</b>';

        priceBlock.insertAdjacentElement('afterend', promo);
    });
});

// -----------------------------------------------------------------------------
// AZADI SALE: advance-payment notice for orders above Rs. 7,500.
// This store uses a quick-cart popup drawer whose contents are injected via
// AJAX after every add/update, so instead of scraping a specific DOM total
// (which differs between the drawer and the full cart page, and gets wiped
// out on every re-render) this fetches the real cart total from /cart.js
// directly and drops the notice into whichever cart UI is present — the
// quick-cart drawer's .previewCart-wrapper, and/or the full cart page's
// .cart-totals list.
// -----------------------------------------------------------------------------
document.addEventListener('DOMContentLoaded', function () {
    var ADVANCE_THRESHOLD_PAISA = 750000; // Rs. 7500
    var NOTICE_TEXT = 'A Rs.\u00A01,000 advance payment is required for orders above Rs.\u00A07,500. Our team will contact you to confirm before dispatch.';

    function buildNotice(tag, extraClass) {
        var el = document.createElement(tag);
        el.className = 'azadi-advance-notice' + (extraClass ? ' ' + extraClass : '');
        el.innerHTML = '<span class="azadi-advance-notice-icon">\u262a</span><span>' + NOTICE_TEXT + '</span>';
        return el;
    }

    function applyNotice(showIt) {
        var totalsList = document.querySelector('.cart-totals');
        if (totalsList) {
            var existing = totalsList.querySelector('.azadi-advance-notice');
            if (showIt && !existing) totalsList.appendChild(buildNotice('li'));
            if (!showIt && existing) existing.remove();
        }

        var previewCart = document.querySelector('.previewCart-wrapper');
        if (previewCart) {
            var existingDrawer = previewCart.querySelector('.azadi-advance-notice');
            if (showIt && !existingDrawer) previewCart.appendChild(buildNotice('div', 'azadi-advance-notice-drawer'));
            if (!showIt && existingDrawer) existingDrawer.remove();
        }
    }

    function refreshCartTotal() {
        fetch('/cart.js')
            .then(function (res) { return res.json(); })
            .then(function (cart) {
                applyNotice(cart.total_price > ADVANCE_THRESHOLD_PAISA);
            })
            .catch(function () {});
    }

    refreshCartTotal();

    if (window.MutationObserver) {
        var debounceTimer;
        var observer = new MutationObserver(function (mutations) {
            var onlyOwnChanges = mutations.every(function (m) {
                var nodes = Array.prototype.slice.call(m.addedNodes).concat(Array.prototype.slice.call(m.removedNodes));
                return nodes.length > 0 && nodes.every(function (n) {
                    return n.classList && n.classList.contains('azadi-advance-notice');
                });
            });
            if (onlyOwnChanges) return;

            clearTimeout(debounceTimer);
            debounceTimer = setTimeout(refreshCartTotal, 250);
        });
        observer.observe(document.body, { childList: true, subtree: true });
    }

    document.addEventListener('submit', function (e) {
        if (e.target && e.target.matches && e.target.matches('form[action*="/cart/add"]')) {
            setTimeout(refreshCartTotal, 700);
        }
    });
});
